import { Skeleton, TableBody, TableRow } from '@mui/material'

import { StyledTableCell } from './index.styles'

export const EmptyState = () => {
  return (
    <TableBody>
      <TableRow>
        <StyledTableCell>
          <Skeleton variant="rectangular" sx={{ my: 1, mx: 1 }} />
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell>
          <Skeleton variant="rectangular" sx={{ my: 1, mx: 1 }} />
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell>
          <Skeleton variant="rectangular" sx={{ my: 1, mx: 1 }} />
        </StyledTableCell>
      </TableRow>
    </TableBody>
  )
}
